import React from 'react';
import { func } from 'prop-types';
import StrategyCard from './StrategyCard/StrategyCard';
import './ApplyLandingPage.scss';

const COMPOSITE_CARD_DESCRIPTION =
  'My jobs are priced to national data cuts and I want to understand how our position to the market and to our salary ranges vary by location.';
const COMPOSITE_CARD_TITLE = 'Apply to market composites and ranges';
const PAGE_TITLE = 'How do you want to apply geo differentials?';

ApplyLandingPage.propTypes = {
  handleStrategyCardClick: func
};

function ApplyLandingPage(props) {
  const { handleStrategyCardClick } = props;

  return (
    <div className="apply-landing-page__container">
      <h3 className="landing-page__header">{PAGE_TITLE}</h3>
      <section className="landing-page__card-container">
        <StrategyCard
          description={COMPOSITE_CARD_DESCRIPTION}
          disabled={false}
          handleStrategyCardClick={handleStrategyCardClick}
          icon="icon-chart-bar"
          id="employees"
          title={COMPOSITE_CARD_TITLE}
        />
      </section>
    </div>
  );
}

export default ApplyLandingPage;
